import { IExercise } from '../../../../../types/interfaces/exercise';
import { IExerciseFilters } from './types';

interface IExerciseFilterValueSet {
  categories: string[];
  muscles: string[];
  equipment: string[];
  developedSkills: string[];
}

function collectExerciseFilterValues(
  exercise: IExercise,
): IExerciseFilterValueSet {
  return {
    categories: [exercise.categoryId].filter(Boolean),
    muscles: [
      exercise.mainMuscleGroupId,
      ...(exercise.additionalMuscles?.map((muscle) => muscle.id) ?? []),
    ].filter(Boolean),
    equipment: [
      exercise.equipmentId,
      ...(exercise.additionalEquipments?.map((equipment) => equipment.id) ??
        []),
    ].filter(Boolean),
    developedSkills: [
      ...(exercise.developedSkills?.map((skill) => skill.id) ?? []),
    ].filter(Boolean),
  };
}

function isCriterionMatched(
  selectedValues: string[],
  availableValues: string[],
): boolean {
  if (!selectedValues.length) {
    return true;
  }

  const availableSet = new Set(availableValues);
  return selectedValues.some((value) => availableSet.has(value));
}

export function matchExerciseWithFilters(
  exercise: IExercise,
  filters: IExerciseFilters,
): boolean {
  const values = collectExerciseFilterValues(exercise);

  return (
    isCriterionMatched(filters.categories, values.categories) &&
    isCriterionMatched(filters.muscles, values.muscles) &&
    isCriterionMatched(filters.equipment, values.equipment) &&
    isCriterionMatched(filters.developedSkills, values.developedSkills)
  );
}

export function filterExercises(
  exercises: IExercise[] | null | undefined,
  filters: IExerciseFilters,
): IExercise[] {
  if (!exercises) {
    return [];
  }

  return exercises.filter((exercise) =>
    matchExerciseWithFilters(exercise, filters),
  );
}
